import AutoModeIcon from '@mui/icons-material/AutoMode';
import React from 'react';

export const AutomationsIcon = ({
	bgColor = '#D2D6E3',
	width = 24,
	height = 24,
	...props
}) => {
	return (
		<AutoModeIcon
			{...props}
			sx={{
				backgroundColor: bgColor,
				width,
				height,
				borderRadius: 2,
				p: 0.5,
				color: '#fff',
			}}
		/>
	);
};
